export enum SummarySectionCategory {
  PRODUCTIVITY = 'Productivity',
  UTILIZATION = 'Utilization',
}

export enum TruckCategory {
  BULLDOZER = 'BullDozer',
  DMU = 'DMU',
}
